import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MortgagePriorityWord } from '@core/util/mortgage';
import {
	DuplicateWarningLabels,
	checkForDuplicatePriority,
} from '@core/util/title-insurance';
import { Encumbrance } from '@models/encumbrance';
import { MatterMortgage } from '@models/mortgage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterEncumbrancesState } from '@state/matter/encumbrances';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { ChangePriorityComponent } from '../../manual/components/change-priority/change-priority.component';

@Component({
	selector: 'app-priority-warning',
	templateUrl: './priority-warning.component.html',
	standalone: false,
})
export class PriorityWarningComponent {
	@SelectSnapshot(MatterEncumbrancesState.getRemain)
	remainEncumbrances: Encumbrance[];
	@SelectSnapshot(MatterMortgagesState.getAllMortgages)
	mortgages: MatterMortgage[];

	public article = 'A';

	@Input() set mortgage(mortgage: MatterMortgage) {
		this.priority = MortgagePriorityWord?.[mortgage?.priority];
		this.showPriorityWarning = checkForDuplicatePriority(
			this.mortgages,
			this.remainEncumbrances,
			mortgage,
		);
		this.article =
			DuplicateWarningLabels.ENCUMBRANCE === this.showPriorityWarning
				? 'An'
				: 'A';
	}

	public showPriorityWarning: string;
	public priority: string;

	constructor(private matDialog: MatDialog) {}

	editPriority(): void {
		this.matDialog.open(ChangePriorityComponent, { panelClass: 'gradient' });
	}
}
